import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import styles from './Tag.module.scss';

export interface TagProps {
  children: React.ReactNode;
  className?: string;
}

const TagComponent: React.FC<TagProps> = ({ children, className }) => (
  <span className={clsx(styles.tag, className)}>{children}</span>
);

export const Tag = TypedMemo(TagComponent);
